import ReactDOM from 'react-dom';
import React, { Suspense, useEffect } from 'react';

import './app.css';

import { BrowserRouter } from 'react-router-dom';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import { createGlobalStyle } from 'styled-components';
import { Colors } from '@blueprintjs/core';
import UAParser from 'ua-parser-js';

import { AuthProvider, useAuth } from '$root/contexts/auth';
//import { A360Provider } from '$root/contexts/a360';
import { ConfigProvider, useConfig } from '$root/contexts/config';
import { Provider, useSelector } from 'react-redux';
import { store } from '$root/store/store';

import { PagePath } from '$pages';
import { LoginPage } from '$pages';
import MainPage from '$pages/main/MainPage';
import { FocusStyleManager } from "@blueprintjs/core";

const uap = new UAParser();


window.deviceType = uap.getDevice()?.type ?? 'desktop';
window.isTablet = window.deviceType === UAParser.DEVICE.TABLET ||
                  window.deviceType === UAParser.DEVICE.MOBILE;
window.isDesktop = !window.isTablet; // && window.deviceType === 'desktop';
// window.isTablet = true

const pdfjsLib = require('pdfjs-dist/build/pdf');
const pdfjsWorker = new Worker(new URL('pdfjs-dist/build/pdf.worker', import.meta.url));

pdfjsLib.GlobalWorkerOptions.workerPort = pdfjsWorker;
pdfjsLib.GlobalWorkerOptions.workerPort.onerror = (err) => {
    console.log('err', err)
}
pdfjsLib.GlobalWorkerOptions.workerPort.onmessage = (msg) => {
}

const uploadLib = require('./components/upload/upload');
import { MakeConfigMessage, MakeUploadMessage } from './components/upload/upload.shared';
const uploadWorker = new Worker(new URL('./components/upload/upload.worker', import.meta.url));


const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        font-family: Overpass, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    
    html, body {
        padding: 0;
        margin: 0;
    }

    html, body {
        width: 100%;
        height: 100%;
    }
    
    #app {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
`;

export const App = (props) => {

    const { user } = useAuth();
    const darkMode = useSelector(state => state.ui.darkMode);

    if (darkMode) {
        document.body.className = "bp4-dark";
        document.body.style.backgroundColor = Colors.DARK_GRAY5;
    }
    else {
        document.body.className = "";
        document.body.style.backgroundColor = "";
    }

    if (!user) {
        const location = useLocation();
        if (location.pathname !== '/login')
            return <Navigate to={PagePath.LOGIN} replace />;
    }

    return (
        <>
            <GlobalStyle />
            <Routes>
                <Route path={PagePath.LOGIN} element={<LoginPage />} />
                <Route path={PagePath.ROOT} element={<MainPage />} />

                <Route path="*" element={<LoginPage />} />
            </Routes>
        </>
    );
}

export const AppRouter = (props) => {

    const { routesBaseName } = useConfig();

    console.log(routesBaseName)
    return (
        <BrowserRouter basename={routesBaseName}>
            <App />
        </BrowserRouter>
    );
}

FocusStyleManager.onlyShowFocusOnTabs();

ReactDOM.render(
    // <React.StrictMode>
        <ConfigProvider>
            <AuthProvider>
                <Provider store={store}>
                    <Suspense fallback="...">
                        <AppRouter />
                    </Suspense>
                </Provider>
            </AuthProvider>
        </ConfigProvider>
    // </React.StrictMode>
    , document.getElementById('app')
);